<template>
  <div>我的考试</div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
